<div class="container-fluid" *ngIf="global_loader">
    <div class="mountroot">
        <div class="loader-container">
            <div class="spinner-spinner">

            </div>
        </div>
    </div>
</div>

<div class="top-right-msg d-flex" (click)="openSampleCart()" [@fadeimagesInOut] *ngIf="isAddSampletoster">
    <div class="msgIMGG">
        <img [src]="msgImg">
    </div>
    <div class="m-auto text-center">
        <p >View on sample cart page</p>
    </div>
</div>
<div class="custom-toast">
    <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"/>
</div>

<div [@fadeimagesInOut] *ngIf="!global_loader">
    <!-------------- NotifyMessage ----------->
    <div id="toast" [ngClass]="{'show':action_complete}">
        <div id="img"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
        <div id="desc">Added..</div>
    </div>
    <!-------------- End NotifyMessage ----------->
    <div *ngIf="!_as.isUserLoggedIn || _as.isDisplayLogin">
        <app-global-login></app-global-login>
    </div>
    <div [ngClass]="{'global-loader':global_loader}">
        <div class="ab-container-full bg-white" id="breadcrumb" *ngIf="!global_loader">
            <div class="ab-container p-16">
                <div class="row breadcrum-container">
                    <nav class="d-flex justify-content-between" aria-label="breadcrumb">
                        <ol class="breadcrumb-list pl-0">
                            <li class="breadcrumb-item " aria-current="page" routerLink="">Home</li>
                            <li class="breadcrumb-item " aria-current="page" (click)="goToDeptPage()">
                                {{currSubCatName}}</li>
                            <li class="breadcrumb-item active" aria-current="page">{{productDetail?.name}}</li>
                        </ol>
                        <button class="back-btn" style="width: fit-content;" (click)="_location.back()"> <i
                                class="fa fa-angle-left "></i> Back</button>
                    </nav>
                </div>
            </div>
        </div>
        <div class="bg-white">
            <div class="m-block top-strip-for-mob-back">
                <div (click)="onBreadcrumb()">
                    <a aria-current="page"> <img
                            src="https://res.cloudinary.com/afterbricks/image/upload/v1682438470/icons/back_g6vjro.png"
                            alt="back to {{category_name}}"></a>
                    <p>{{currSubCatName}}<br><span class="active-types-name"> {{productDetail?.name}}</span>
                    </p>
                </div>
            </div>
            <div class="product-detail-container product-top-padding p-flex sec-pt-2 pb-0 p-detail-top-row" #productSection>
                <div class="product-image-media">
                    <ul class="products-thumbnail" *ngIf="productDetail?.image_list.length > 1 && !global_loader">
                        <li *ngFor="let img of productDetail?.image_list;let imgi=index">
                            <a class="p-thumbnail" (mouseover)="selectImg(imgi)"
                                [ngClass]="{'active-img':imgi===activeImgIndex}">
                                <img ngOptimizedImage loading="lazy" ngSrc="{{img?.image}}" width="89" height="89" id="show-img"
                                    [alt]="productDetail?.name">
                            </a>
                        </li>
                    </ul>
                    <!-------------loader------------------>
                    <!-- <ul class="products-thumbnail is-loading" *ngIf="global_loader" style="margin: 8px 20px 0 0;">
                <li *ngFor="let img of [1,2,3,4];">
                    <a class="p-thumbnail product-img-1">
                    </a>
                </li>
            </ul> -->
                    <!----------------end loader--------------------->
                    <div class="px-0 product-img-section position-relative" *ngIf="!global_loader">
                        
                        <div *ngIf="productDetail?.image_list[0]?.image" class="product-m-image product-m-image-tab"
                             style="cursor: pointer;" >
                             
                            <img ngOptimizedImage loading="lazy" data-zoom="https://s3-afterbricks.s3.amazonaws.com/media/haier/306332_3.png"
                                [src]="this.productDetail?.image_list[activeImgIndex].image" width="965" height="500" id="show-img-full"
                                class="drift-demo-trigger mx-auto my-auto" style="cursor: zoom-in;height: auto; width: auto; /* Optional: change cursor when hovering */" [alt]="productDetail?.name" (click)="onSelectImage()">
                        </div>
                      <div class="wt-block">
                        <div class="  cp shareimage text-left" style="align-items: center; margin-top:16px;display: flex;">
                            <span class="ng-tns-c7-9 color-s wt-block"
                                style="font-size: 0.875rem; font-family: 'SF UI Text Regular'!important;padding-right: 8px;">Share</span>
                            <share-buttons [theme]="'circles-dark'"
                                [include]="['whatsapp','facebook','pinterest','linkedin']" [show]="4"
                                [tags]="'afterbricks'">
                            </share-buttons>
                        </div>
                        <div>
                            <div class="get-sample-at-home-card" (click)="addToSampleList(productDetail)" *ngIf="productDetail?.sample_status==='available'">
                                <div class="get-come-soon">
                                </div>
                                
                                 <div class="get-sample-at-home-btn" >
                                     <div class="get-come-soon-img">
                                         <img  src="https://res.cloudinary.com/afterbricks/image/upload/v1735218761/sample-colot-icon_ss5obr.png"
                                         alt="get-come-soon">
                                        </div>
                                   <div class="get-come-soon-text">
                                     <h3>Book free sample</h3>
                                   </div>
                                 </div>
                             </div>
                            <div class="get-sample-at-home-card"   *ngIf="productDetail?.sample_status==='Booked'">
                                <div class="get-come-soon">
                               
                                </div>
                                
                                 <div class="get-sample-at-home-btn sample-booked-btn" (click)="openSampleCart()" >
                                    <!-- (click)="onSampleOrders()" -->
                                     <div class="get-come-soon-img">
                                         <img  src="https://res.cloudinary.com/afterbricks/image/upload/v1735378345/samples_2_t6mkiv.png"
                                         alt="get-come-soon">
                                        </div>
                                   <div class="get-come-soon-text">
                                     <h3> Sample booked</h3>
                                    
                                   </div>
                                 </div>
                             </div>
                        </div>
                      </div>
                        <p-galleria [value]="productDetail?.image_list" [(visible)]="isDisplayImage"
                            [containerStyle]="{'max-width': '100%'}" [circular]="false" [fullScreen]="true"
                            [showItemNavigators]="productDetail?.image_list?.length > 1" [showThumbnails]="false"
                            [baseZIndex]="100000">
                            <ng-template pTemplate="item" let-item>
                                <img ngOptimizedImage loading="lazy" [src]="item.image" 
                                    style="width: 100%; max-height: 80vh; display: block;" alt="See it in your space" />
                            </ng-template>
                        </p-galleria>
                        
                    </div>
                    <!------------------------------------------------ 3d-img-section -------------------------------------->
                        <!-- <div *ngIf="productDetail?.id==7581">
                            <div data-threedy-web-id="0200012604" data-threedy-sku="default">
                                <button class="threedy-qar-btn threedy-embed-btn" style="display: none;">
                                    <img ngOptimizedImage loading="lazy" style="margin-right: 10px;"
                                        src="https://res.cloudinary.com/afterbricks/image/upload/v1653568951/icons/Group_3_tzofw7.svg"
                                        alt="See it in your space">See it in your space
                                </button>
                            </div>
                        </div> -->
                        <!------------------------------------------------ end 3d-img-section -------------------------------------->

                    <!----------------loader------------------------>
                    <!-- <div class="px-0 product-img-section is-loading" *ngIf="global_loader">
                <div class="product-m-image product-img-1"></div>
            </div> -->
                    <!-----------------end loader----------------------->
                </div>
                <div class="product-detail-section detail">
                    <div id="product-offer-section" class="product-offer-section" *ngIf="!global_loader">
                        <h2 class="product-name">
                            {{productDetail?.name}}
                        </h2>
                        <div class="rating-box" *ngIf="productDetail?.average_rating">
                            <p-rating [(ngModel)]="productDetail.average_rating" [readonly]="true" [cancel]="false"></p-rating>
                            <span class="rating-score" (click)="scroll('customer-review')">{{ productDetail?.average_rating || 0 }} ({{ productDetail?.total_reviews }} reviews)</span>
                          </div>
                       <div class="brand-link">
                        <a routerLink="../../brand/{{productDetail?.brand_slug_name}}" [title]="productDetail?.brand_name" [queryParams]="{catId:productDetail?.sub_category_id}">
                          Visit the {{productDetail?.brand_name}} Store</a>
                       </div>
                        <div class="product-card-content1" >
                            <div class="d-flex justify-content-between hr">
                                <div class="product-code-trip">
                                    <p [ngClass]="{'border-0':productDetail?.sku}">Brand : <span>{{productDetail?.brand_name}}</span> </p>
                                    <p *ngIf="productDetail?.sku">SKU Code : <span>{{productDetail?.sku}}</span> </p>
                                </div>

                            </div>
                            <div class="product-op-container" *ngIf="options.length">
                                <div class="product-option-list" *ngFor="let op of options;let opi=index">
                                    <div class="product-option-card">
                                        <div class="option-name">
                                            select {{op?.name}}:
                                        </div>
                                        <div class="option-values-box" *ngIf="op?.option_values?.length">
                                            <div class="option-vlues"
                                                [ngClass]="{'pointer-events-none':opv.prodID===productDetail?.id,}"
                                                *ngFor="let opv of op?.sort_op_values;let opvi=index">
                                                <div class="option-value-card" *ngIf="op?.is_show_image"
                                                    (click)="onOptionProduct(opv?.slug_name)">
                                                    <div class="option-value-img"
                                                        [ngClass]="{'active-option-value-img':opv.prodID===productDetail?.id}">
                                                        <img ngOptimizedImage loading="lazy" [ngSrc]="opv?.image" width="70" height="70"
                                                            [alt]="opv?.product_name">
                                                    </div>
                                                    <div class="option-value-text">
                                                        {{opv?.name}}
                                                    </div>
                                                </div>
                                                <div class="option-value-text-link"
                                                    (click)="onOptionProduct(opv?.slug_name)"
                                                    *ngIf="!op?.is_show_image">
                                                    {{opv?.name}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="productDetail?.price">
                                <div class="price-offer"
                                    *ngIf="productDetail?.calculation_type !=='sqft_wise' && productDetail?.calculation_type !=='sheet_wise' && productDetail?.calculation_type !=='meter_wise'">
                                    <div class="ab-price" *ngIf="!productDetail?.discount"><span>From:</span>
                                        <sup>&#8377;</sup>{{productDetail?.price | number:'1.0-1'}}
                                    </div>
                                    <div class="ab-price off" *ngIf="productDetail?.discount">
                                        <span>From:</span>
                                        <sup>&#8377;</sup>{{productDetail?.effective_price | number:'1.0-1'}}
                                        <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{productDetail?.price
                                                |
                                                number:'1.0-1'}}</s></span>
                                        <span class="dis-off">{{productDetail?.discount}}% off</span>
                                    </div>
                                    <div class="d-flex">
                                        <p class="taxes" style="margin-right: 8px;">{{_as.price_help_text}}</p>
                                        <div class="cashback-chip-2" *ngIf="productDetail?.cashback?.cashback">
                                            <p> Cashback {{productDetail?.cashback?.cashback}}%</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="price-offer" *ngIf="productDetail?.calculation_type ==='sqft_wise'">
                                    <div class="ab-price" *ngIf="!productDetail?.discount"><span>Price:</span>
                                        <sup>&#8377;</sup>{{productDetail?.price | number:'1.0-1'}} <span
                                            style="font-size: 12px;">/sqft</span>
                                    </div>
                                    <div class="ab-price" *ngIf="productDetail?.discount">
                                        <span>From:</span>
                                        <sup>&#8377;</sup>{{productDetail?.effective_price | number:'1.0-1'}} <span
                                            style="font-size: 12px;">/sqft</span>
                                        <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{productDetail?.price
                                                |
                                                number:'1.0-1'}}</s></span>
                                        <span class="dis-off"> {{productDetail?.discount}}% off</span>
                                    </div>
                                    <p class="taxes">{{_as.price_help_text}}</p>
                                    <div>
                                        <ul class="per-box-ul">
                                            <li>
                                                <div class="per-box">
                                                    <p>Size: </p>
                                                    <p>
                                                        {{productDetail?.width | number:'1.2-2'}} ft X
                                                        {{productDetail?.height |
                                                        number:'1.2-2'}} ft / Pc
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="per-box">
                                                    <p>Quantity: </p>
                                                    <p>{{productDetail?.in_box}} Pcs / Box</p>

                                                </div>
                                            </li>
                                            <li>
                                                <div class="per-box">
                                                    <p>Coverage Area </p>
                                                    <p>{{productDetail?.covered_area_par_box | number:'1.2-2'}} sqft /
                                                        Box</p>

                                                </div>
                                            </li>
                                        </ul>

                                        <div class="sqft-calculator">
                                            <div class="sqft-area-wise">
                                                <span>Total Area (sq ft)</span>
                                                <input type="number" [(ngModel)]="areaSqft"
                                                    (keyup)="areaWiseCalculat()">
                                            </div>
                                            <div class="total-sqft-area-price">
                                                <p class="total-sqft-area-price-p"><span>Total Price:</span>
                                                    &#8377;{{total_Sqft_amount
                                                    |
                                                    number:'1.0-1'}}</p>
                                                <p class="taxes">{{_as.price_help_text_one}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="price-offer" *ngIf="productDetail?.calculation_type ==='sheet_wise'">
                                    <div class="ab-price" *ngIf="!productDetail?.discount"><span>price:</span>
                                        <sup>&#8377;</sup>{{productDetail?.price | number:'1.0-1'}} <span
                                            style="font-size: 12px;margin-top: 12px;">/sqft</span>
                                    </div>
                                    <div class="ab-price" *ngIf="productDetail?.discount">
                                        <span>From:</span>
                                        <sup>&#8377;</sup>{{productDetail?.effective_price | number:'1.0-1'}} <span
                                            style="font-size: 12px;margin-top: 12px;">/sqft</span>
                                        <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{productDetail?.price
                                                |
                                                number:'1.0-1'}}</s></span>
                                        <span class="dis-off"> {{productDetail?.discount}}% off</span>
                                    </div>
                                    <p class="taxes">{{_as.price_help_text}}</p>
                                    <ul class="per-box-ul">
                                        <li>
                                            <div class="per-box">
                                                <p>Coverage Area </p>
                                                <p>{{productDetail?.covered_area_par_sheet | number:'1.2-2'}} sqft /
                                                    Board</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="per-box">
                                                <p>From </p>
                                                <p>&#8377; {{productDetail?.par_box_amount | number:'1.0-1'}} / Board
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="sqft-calculator">
                                        <div class="total-sqft-area-price">
                                            <p class="total-sqft-area-price-p"><span>Total Price:</span>
                                                &#8377;{{total_Sqft_amount |
                                                number:'1.0-1'}}</p>
                                            <p class="taxes">{{_as.price_help_text_one}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="price-offer" *ngIf="productDetail?.calculation_type ==='meter_wise'">
                                    <div class="ab-price" *ngIf="!productDetail?.discount"><span>price:</span>
                                        <sup>&#8377;</sup>{{productDetail?.price | number:'1.0-1'}} <span
                                            style="font-size: 12px;margin-top: 12px;">/meter</span>
                                    </div>
                                    <div class="ab-price" *ngIf="productDetail?.discount">
                                        <span>From:</span>
                                        <sup>&#8377;</sup>{{productDetail?.effective_price | number:'1.0-1'}} <span
                                            style="font-size: 12px;margin-top: 12px;">/meter</span>
                                        <span class="pp" style="margin-top: 4px;"> <s>MRP &#8377;{{productDetail?.price
                                                |
                                                number:'1.0-1'}}</s></span>
                                        <span class="dis-off"> {{productDetail?.product_calculation?.discount}}% off</span>
                                    </div>
                                    <p class="taxes">{{_as.price_help_text}}</p>
                                    <ul class="per-box-ul">
                                        <li>
                                            <div class="per-box">
                                                <p>Roll length  </p>
                                                <p>{{productDetail?.product_calculation?.length}} Meter /
                                                    Roll</p>
                                            </div>
                                        </li>
                                        <!-- <li>
                                            <div class="per-box">
                                                <p>From </p>
                                                <p>&#8377; {{productDetail?.par_box_amount | number:'1.0-1'}} / Board
                                                </p>
                                            </div>
                                        </li> -->
                                    </ul>
                                    <div class="sqft-calculator">
                                        <div class="total-sqft-area-price">
                                            <p class="total-sqft-area-price-p"><span>Total Price:</span>
                                                &#8377;{{totalamount |
                                                number:'1.0-1'}}</p>
                                            <p class="taxes">{{_as.price_help_text_one}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hr-1" *ngIf="productDetail?.price"></div>
                        <div class="w-block">
                            <div class="offer-strip">
                                 <div class="offer-strip-img">
                                    <img ngOptimizedImage loading="lazy" src="assets/images/home/discount.png"
                                        alt="offer">
                                </div>
                                <div class="offer-strip-text">
                                    <span >Get the best offer in "My cart"</span>
                                </div>
                            </div>
                            <div class="action-btn-conatiner" *ngIf="!is_addToCart">
                                <div class="d-flex">
                                    <div class="product-quantity" >
                                        <div class="product-btns">
                                            <span class="sqft-box-wise-span"
                                                *ngIf="productDetail?.calculation_type ==='sqft_wise'">Box
                                                Quantity</span>
                                            <span class="sqft-box-wise-span"
                                                *ngIf="productDetail?.calculation_type ==='sheet_wise'">Board
                                                Quantity</span>
                                            <button [ngClass]="{'product-btns-disabled':quantity === 1 }"
                                                (click)="decreaseQty()">-</button>
                                            <input type="text" [(ngModel)]="quantity" min="1" [max]="max_value_qty"
                                                (keyup)="addQty()">
                                            <button (click)="increaseQty()"
                                                [ngClass]="{'product-btns-disabled':(quantity===20 && productDetail?.calculation_type !=='sqft_wise') }">+</button>

                                        </div>
                                    </div>
                                    <button class="addtolistbtn-save-idea" (click)="addToCart(productDetail)">
                                     Add To My cart
                                    </button>
                                </div>
                                  <div style="margin-top:12px">
                                    <div class="save-btn-and-link pb-2">
                                        <button class="save-idea-btn w-100" (click)="addProductSpace(productDetail)"
                                            *ngIf="!is_addToCart && !productDetail?.is_already_selected">
                                            <svg width="18" height="17" viewBox="0 0 19 17" fill="none"
                                                style=" margin-right: 8px;" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                                                    fill="#fc9918" />
                                            </svg>
                                            Save idea
                                        </button>
                                        <button class="save-idea-btn w-100" (click)="goToSaveIdea()"
                                            *ngIf="productDetail?.is_already_selected">
                                            Already Selected
                                        </button>
                                    </div>
                                     <p class="quaty-nxt-step">
                                <span style="color:#222; font-size:14px;font-family:'SF UI Text Bold';">Note:</span>
                                &nbsp;Add Quantity in Save-idea or My cart
                              </p>
                              <p>
                                <span style="color:#222; font-size:13px;font-family:'SF UI Text Light';">Design room-wise mood boards with ‘Save Idea’</span>
                              </p>
                                </div>
                            </div>
                        </div>
                            <div class="m-block actfixd-btn-mob" [ngClass]="{'position-static':!isSticky}">
                              <div class="action-btn-conatiner" *ngIf="!is_addToCart">
                                <div>
                                    <div class="save-btn-and-link pb-2">
                                        <button class="save-idea-btn w-100" (click)="addProductSpace(productDetail)"
                                            *ngIf="!is_addToCart && !productDetail?.is_already_selected">
                                            <svg width="18" height="17" viewBox="0 0 19 17" fill="none"
                                                style=" margin-right: 8px;" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                                                    fill="#fc9918" />
                                            </svg>
                                            Save idea
                                        </button>
                                        <button class="save-idea-btn w-100" (click)="goToSaveIdea()"
                                            *ngIf="productDetail?.is_already_selected">
                                            Already Selected
                                        </button>
                                         <button class="addtolistbtn-save-idea" style="margin-left: 8px;"
                                        (click)="addToCart(productDetail)">Add To My cart</button>
                                    </div>
                                 </div> 
                              </div>
                             
                           </div>
                                 <div class="m-block">
                                    <div class="get-sample-at-home-card" (click)="addToSampleList(productDetail)"  *ngIf="productDetail?.sample_status==='available'">
                                        <div class="get-come-soon">
                                        </div>
                                        
                                         <div class="get-sample-at-home-btn" >
                                             <div class="get-come-soon-img">
                                                 <img  src="https://res.cloudinary.com/afterbricks/image/upload/v1735218761/sample-colot-icon_ss5obr.png"
                                                 alt="get-come-soon">
                                                </div>
                                           <div class="get-come-soon-text">
                                             <h3>Book free sample</h3>
                                           </div>
                                         </div>
                                     </div>
                                    <div class="get-sample-at-home-card"   *ngIf="productDetail?.sample_status==='Booked'">
                                        <div class="get-come-soon">
                                       
                                        </div>
                                        
                                         <div class="get-sample-at-home-btn sample-booked-btn"  (click)="openSampleCart()">
                                            <!-- (click)="onSampleOrders()" -->
                                             <div class="get-come-soon-img">
                                                 <img  src="https://res.cloudinary.com/afterbricks/image/upload/v1735378345/samples_2_t6mkiv.png"
                                                 alt="get-come-soon">
                                                </div>
                                           <div class="get-come-soon-text">
                                             <h3> Sample booked</h3>
                                            
                                           </div>
                                         </div>
                                     </div>
                                </div>

                           
                          <div class="wt-block">
                              <div class="save-btn-and-link pb-2 wt-block" *ngIf="is_addToCart">
                                <button class="add-more-pro-btn" (click)="onBack()">
                                    Add products
                                </button>
                                <button class="addtolistbtn-save-idea" (click)="goToProductDetail()">Go to cart
                                </button>
                            </div>
                          </div>
                             <div class="m-block actfixd-btn-mob" [ngClass]="{'position-static':!isSticky}">
                              <div class="save-btn-and-link pb-2 wt-block" *ngIf="is_addToCart">
                                <button class="add-more-pro-btn" (click)="onBack()">
                                    Add products
                                </button>
                                <button class="addtolistbtn-save-idea" (click)="goToProductDetail()">Go to cart
                                </button>
                            </div>
                            </div>
                            <!-- <p class="website-p" *ngIf="websiteUrl">
                                see this product in
                                <a [href]="websiteUrl" target="_blank"
                                    [title]="productDetail?.brand_name">{{productDetail?.brand_name}} website </a>
                            </p> -->
                            <div class="m-block mb-2">
                             <div class="offer-strip">
                                 <div class="offer-strip-img">
                                    <img ngOptimizedImage loading="lazy" src="assets/images/home/discount.png"
                                        alt="offer">
                                </div>
                                <div class="offer-strip-text">
                                    <span >Get the best offer in "My cart"</span>
                                </div>
                              </div>
                               <p class="quaty-nxt-step">
                                <span style="color:#222; font-size:14px;font-family:'SF UI Text Bold';">Note:</span>
                                &nbsp;Add Quantity in Save-idea or My cart
                              </p>
                              <p>
                                <span style="color:#222; font-size:13px;font-family:'SF UI Text Regular';">Design room-wise mood boards with ‘Save Idea’</span>
                              </p>
                            </div>
                           
                            <div class=" m-block cp shareimage text-left" style="align-items: center;">

                                <span class="ng-tns-c7-9 color-s wt-block"
                                    style="font-size: 0.875rem; font-family: 'SF UI Text Regular'!important;padding-right: 8px;">Share</span>
                                <div class="share-icon-mob m-block">
                                    <img ngOptimizedImage loading="lazy" src="../../assets/images/icon/share.png"
                                        alt="Share">
                                </div>
                                <share-buttons [theme]="'circles-dark'"
                                    [include]="['whatsapp','facebook','pinterest','linkedin']" [show]="4"
                                    [tags]="'afterbricks'">
                                </share-buttons>
                            </div>
                          <div class="come-soon-section">
                          
                            
                          </div>
                        </div>
                    </div>
                    <!-------------------loader------------------------------>
                    
                    <!-------------------end loader------------------------------------>
                </div>
            </div>
            <div class="product-detail-container bt-sec">
                <div class=" live-offers-sec d-flex flex-wrap w-100 ">
                    <div class="act-btn-sec-width order-md-2 order-sm-1">
                        <div class="four-btn d-flex">
                            <button class="act-btn" *ngIf="websiteUrl">
                               <a [href]="websiteUrl" target="_blank"
                                   [title]="productDetail?.brand_name">{{productDetail?.brand_name}} Website</a>
                           </button>
                            <button class="act-btn" (click)="onRequest('Price list')">
                              Request Quote</button>

                            <!-- <button class="act-btn">
                                VIEW CATALOGUE
                           </button> -->

                           <!-- <button class="act-btn" style="opacity: .8;border: none;cursor: none;">
                            <div class="ins-come-soon">
                                <div class="ins-come-soon-box">
                                    <span>Coming soon</span>
                                </div>  
                               </div>
                              Book Easy Installation</button> -->
                        </div>
                       
                    </div>
                  
                 
                </div>
            </div>
            <div class="product-container all-section-container" *ngIf="!global_loader">
                <div class="row product-detail-container" id="specification">
                    <div class="col-12 px-0">
                        <div class="section-heading">
                            specification
                        </div>
                        <div class="section-body">
                            <div class="w-block">
                                <div class="d-flex">
                                    <div class="image-section">
                                        <img ngOptimizedImage loading="lazy" ngOptimizedImage loading="lazy"
                                            [ngSrc]="productDetail?.image_list[0]?.image" width="240" height="240" alt="productDetail?.name">
                                    </div>
                                    <div class="content-section">
                                        <div class="spec-list">
                                            <div class="spec-card">
                                                <div class="spec-title">Product Category</div>
                                                <div class="spec-value">{{productDetail?.category_type?.name}}</div>
                                            </div>
                                            <div class="spec-card" *ngFor="let al of attribute_list">
                                                <div class="spec-title">{{al?.name}}</div>
                                                <div class="spec-value">{{al?.value}}</div>
                                            </div>
                                            <div class="spec-card" *ngIf="productDetail?.weight">
                                                <div class="spec-title">Weight</div>
                                                <div class="spec-value">{{productDetail?.weight}} Kg</div>
                                            </div>
                                            <div class="spec-card" *ngIf="productDetail?.in_box">
                                                <div class="spec-title">Package Content </div>
                                                <div class="spec-value">{{productDetail?.in_box}} pc</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                              
                                <!---------------------loader------------------------------->
                            </div>
                            <div class="t-block ">
                                <div class="row" *ngIf="!global_loader">
                                    <div class="spec-card" *ngFor="let al of attribute_list">
                                        <div class="spec-title">{{al?.name}}</div>
                                        <div class="spec-value">{{al?.value}}</div>
                                    </div>
                                    <div class="spec-card" *ngIf="productDetail?.weight">
                                        <div class="spec-title">Weight</div>
                                        <div class="spec-value">{{productDetail?.weight}} Kg</div>
                                    </div>
                                    <div class="spec-card" *ngIf="productDetail?.in_box">
                                        <div class="spec-title">Package Content </div>
                                        <div class="spec-value">{{productDetail?.in_box}} pc</div>
                                    </div>

                                </div>
                              
                            </div>

                            <div class="m-block">
                                <div class="row sticky-nav " [ngClass]="{'sticky-nav':is_top_product_header}"
                                    *ngIf="!global_loader">
                                    <div class="image-section" *ngIf="is_top_product_header">
                                        <img ngOptimizedImage loading="lazy" 
                                            [ngSrc]="productDetail?.image_list[0]?.image" width="60" height="60" [alt]="productDetail?.name">
                                    </div>
                                    <div class="produc-name" *ngIf="is_top_product_header">
                                        <div class="band-nam"> {{productDetail?.name}}</div>

                                        <div class="pro-nam" *ngIf="productDetail?.sku">
                                            <p>SKU Code:<span>{{productDetail?.sku}}</span> </p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row" *ngIf="!global_loader">

                                    <div class="spec-card" *ngFor="let al of attribute_list">
                                        <div class="spec-title">{{al?.name}}</div>
                                        <div class="spec-value">{{al?.value}}</div>
                                    </div>
                                    <div class="spec-card" *ngIf="productDetail?.weight">
                                        <div class="spec-title">Weight</div>
                                        <div class="spec-value">{{productDetail?.weight}} Kg</div>
                                    </div>
                                    <div class="spec-card" *ngIf="productDetail?.in_box">
                                        <div class="spec-title">Package Content </div>
                                        <div class="spec-value">{{productDetail?.in_box}} pc</div>
                                    </div>

                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-block middle-navbar" #navbar *ngIf="!global_loader">
                    <ul>
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'description'}"
                            *ngIf="full_description?.length">
                            <a class="middle-link" (click)="scroll('description')" target="_self"
                                title="Product Description">Product Description
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'description'"></div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'description'"></div>
                            </a>
                        </li>
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'product-details'}">
                            <a class="middle-link" (click)="scroll('product-details')" target="_self"
                                title="Product Details">Product Details
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'product-details'"></div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'product-details'"></div>
                            </a>
                        </li>
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'compare-similar'}"
                            *ngIf="similar_product_list?.length">
                            <a class="middle-link" (click)="scroll('compare-similar')" target="_self"
                                title="Compare Similar">Compare Similar
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'compare-similar'"></div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'compare-similar'"></div>
                            </a>
                        </li>
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'compatible-products' }"
                            *ngIf="support_product_list?.length">
                            <a class="middle-link" (click)="scroll('compatible-products')" target="_self"
                                title="Compatible Products">Compatible Products
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'compatible-products'">
                                </div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'compatible-products'"></div>
                            </a>
                        </li>
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'combination' }"
                        *ngIf="product_collection_list?.length">
                        <a class="middle-link" (click)="scroll('combination')" target="_self"
                            title="combination">combination
                            <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'combination'"></div>
                            <div class="middle-link-hover" *ngIf="activeTab !== 'combination'"></div>
                        </a>
                    </li>
                  <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'recently-viewed'}"
                    *ngIf="recentlyViewedProducts?.length">
                    <a class="middle-link" (click)="scroll('recently-viewed')" target="_self"
                        title="Recently Viewed">Recently Viewed
                        <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'recently-viewed'"></div>
                        <div class="middle-link-hover" *ngIf="activeTab !== 'recently-viewed'"></div>
                    </a>
                    </li>
                        <!-- <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'nearby-sallers'}">
                            <a class="middle-link" (click)="scroll('nearby-sallers')" target="_self"
                                title="Near By Sellers">Near By Sellers
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'nearby-sallers'"></div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'nearby-sallers'"></div>
                            </a>
                        </li> -->
      
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'questions-answers' }"
                            *ngIf="!_as.isProduction">
                            <a class="middle-link" (click)="scroll('questions-answers')" target="_self"
                                title="Q&A (3)">Q&A (3)
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'questions-answers'">
                                </div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'questions-answers'"></div>
                            </a>
                        </li>
                        <li class="middle-item" [ngClass]="{'is-current':activeTab=== 'shipping-returns'}"
                            *ngIf="!_as.isProduction">
                            <a class="middle-link" (click)="scroll('shipping-returns')" target="_self"
                                title="Shipping & Returns">Shipping & Returns
                                <div class="activ-middle-link-bottom-line" *ngIf="activeTab=== 'shipping-returns'">
                                </div>
                                <div class="middle-link-hover" *ngIf="activeTab !== 'shipping-returns'"></div>
                            </a>
                        </li>
                    </ul>
                </div>

                <div id="description" class="row product-detail-container product-detail-padd" *ngIf="full_description?.length">
                    <div class="col-12 px-0">
                        <div class="bg-white">
                            <div id="product-description-section" class="product-description-section">
                                <div class="section-heading">
                                    description
                                </div>
                                <div class="section-body-1 pb-0" *ngIf="full_description?.length">
                                    <div class="ppd-discription w-100" *ngIf="full_description?.length">
                                        <app-read-more class="prodReadMore" [text]="full_description" [maxLength]="250">
                                        </app-read-more>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                        </div>
                    </div>
                </div>
                <div id="product-details" class="row product-detail-container" *ngIf="!global_loader">
                    <div class="col-12 px-0">
                        <div class="product-specification-section  ">
                            <div class="section-heading">
                                details
                            </div>
                            <div class="w-block ">
                                <div class="section-body  p-14">
                                    <div class="row"
                                        style="border: 1px solid #dee2e6;border-radius: 0px;overflow: hidden;border-bottom:none; border-right:none;">
                                        <div class="col-md-6 col-sm-12 px-0" *ngIf="firstproductDetailOption.length">
                                            <div class="product-detail" 
                                                *ngFor="let p_detail of firstproductDetailOption;let last=last">

                                                <div class="row">
                                                    <div class="col key-bg" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-name">{{p_detail?.key}}</div>
                                                    </div>
                                                    <div class="col" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-value">{{p_detail?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12 px-0" *ngIf="secoundproductDetailOption.length">
                                            <div class="product-detail" 
                                                *ngFor="let p_detail of secoundproductDetailOption;let last=last">

                                                <div class="row">
                                                    <div class="col key-bg" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-name">{{p_detail?.key}}</div>
                                                    </div>
                                                    <div class="col" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-value">{{p_detail?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12 px-0" *ngIf="thirdproductDetailOption.length">
                                            <div class="product-detail" [ngClass]="{'border-bottom-0':last}"
                                                *ngFor="let p_detail of thirdproductDetailOption;let last=last">

                                                <div class="row">
                                                    <div class="col key-bg" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-name">{{p_detail?.key}}</div>
                                                    </div>
                                                    <div class="col">
                                                        <div class="att-value">{{p_detail?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!------------loader-------------->
                                      <!----------end loader-------------->
                                </div>
                            </div>

                            <div class="t-block">
                                <div class="section-body  p-14">
                                    <div class="row"
                                        style="border: 1px solid #dee2e6;border-radius: 0px;overflow: hidden;"
                                        *ngIf="!global_loader">
                                        <div class="col-md-6 col-sm-12 px-0" *ngIf="firstproductDetailOption.length">
                                            <div class="product-detail" [ngClass]="{'border-bottom-0':last}"
                                                *ngFor="let p_detail of firstproductDetailOption;let last=last">

                                                <div class="row">
                                                    <div class="col key-bg" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-name">{{p_detail?.key}}</div>
                                                    </div>
                                                    <div class="col" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-value">{{p_detail?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12 px-0" *ngIf="secoundproductDetailOption.length">
                                            <div class="product-detail" [ngClass]="{'border-bottom-0':last}"
                                                *ngFor="let p_detail of secoundproductDetailOption;let last=last">

                                                <div class="row">
                                                    <div class="col key-bg" style="border-right: 1px solid #dee2e6;">
                                                        <div class="att-name">{{p_detail?.key}}</div>
                                                    </div>
                                                    <div class="col">
                                                        <div class="att-value">{{p_detail?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!------------loader-------------->
                                    
                                    <!----------end loader-------------->
                                </div>
                            </div>

                            <div class="m-block">
                                <div class="section-body  p-14"
                                    *ngIf="firstproductDetailOption?.length && !global_loader">
                                    <div class="product-detail-key-value-list" *ngIf="firstproductDetailOption.length">
                                        <div class="product-detail-key-value"
                                            *ngFor="let p_detail of firstproductDetailOption;let last=last">
                                            <div class="detail-key">
                                                <div class="att-name">{{p_detail?.key}}</div>
                                            </div>
                                            <div class="detail-value">
                                                <div class="att-value">{{p_detail?.value}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="product-detail-key-value-list border-top-0"
                                        *ngIf="secoundproductDetailOption.length">
                                        <div class="product-detail-key-value"
                                            *ngFor="let p_detail of secoundproductDetailOption;let last=last">
                                            <div class="detail-key">
                                                <div class="att-name">{{p_detail?.key}}</div>
                                            </div>
                                            <div class="detail-value">
                                                <div class="att-value">{{p_detail?.value}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>

                        </div>

                    </div>
                </div>

                <div class="row product-detail-container" *ngIf="similar_product_list.length && !global_loader">
                    <div class="col-12 px-0" id="compare-similar">
                        <div class="section-heading">
                            compare similar items
                        </div>
                        <div class="section-body pb-0" style="position: relative;">
                            <div class="w-block">
                                <button class="scroll-prev-btn" (click)="scrollPrev()" style="opacity: 0.5;"><i
                                        class="fa fa-angle-left" aria-hidden="true"></i></button>
                                <button class="scroll-next-btn" (click)="scrollNext()"><i class="fa fa-angle-right"
                                        aria-hidden="true"></i></button>
                                <div class="comp-conatiner">
                                    <div class="comp-card comp-product-keys">
                                        <div class="comp-img"></div>
                                        <div class="comp-content">
                                            <ul class="comp-list-ul comp-list-ul-bg border-0">
                                                <li class="comp-item border-0">
                                                    <div class="comp-link">Brand</div>
                                                </li>
                                                <li class="comp-item border-0">
                                                    <div class="comp-link">Price</div>
                                                </li>
                                                <li class="comp-item border-0"
                                                    *ngFor="let mat of master_attribute_list">
                                                    <div class="comp-link">{{mat}}</div>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                    <div class="comp-list" #compList>
                                        <ng-container *ngFor="let prod of similar_product_list;let pi-index">
                                            <div class="comp-card compare-prod-card"
                                                *ngIf="prod?.image_list[0]?.image_url">
                                                <div class="comp-img">
                                                    <img ngOptimizedImage loading="lazy"
                                                        [ngSrc]="prod?.image_list[0]?.image_url" width="400" height="200" [alt]="prod?.name"
                                                        *ngIf="prod?.image_list[0]?.image_url">
                                                </div>
                                                <div class="comp-content">
                                                    <ul class="comp-list-ul">
                                                        <li class="comp-item">
                                                            <div class="comp-link">{{prod?.brand}} </div>
                                                        </li>
                                                        <li class="comp-item price-cashback">
                                                            <div *ngIf="prod?.price">
                                                                <a class="comp-link"
                                                                    *ngIf="!prod?.discount && (prod?.calculation_type !== 'sqft_wise' && prod?.calculation_type !== 'sheet_wise' && prod?.calculation_type !== 'meter_wise')">
                                                                    &#8377;<span class="price">{{prod?.price |
                                                                        number:'1.0-1'}}</span> </a>
                                                                <a class="comp-link"
                                                                    *ngIf="prod?.discount && (prod?.calculation_type !== 'sqft_wise' && prod?.calculation_type !== 'sheet_wise' && prod?.calculation_type !== 'meter_wise')">&#8377;
                                                                    <span class="price">{{prod?.effective_price |
                                                                        number:'1.0-1'}}</span> <span class="mrp">
                                                                        <s> MRP &#8377;{{prod?.price |
                                                                            number:'1.0-1'}}</s></span> <span
                                                                        class="dis">
                                                                        {{prod?.discount}}% off</span> </a>
                                                                <a class="comp-link"
                                                                    *ngIf="!prod?.discount && (prod?.calculation_type === 'sqft_wise' || prod?.calculation_type === 'sheet_wise')">
                                                                    &#8377;<span class="price">{{prod?.price |
                                                                        number:'1.0-1'}}/sqft</span> </a>
                                                                <a class="comp-link"
                                                                    *ngIf="prod?.discount && (prod?.calculation_type === 'sqft_wise' || prod?.calculation_type === 'sheet_wise')">&#8377;
                                                                    <span class="price">{{prod?.effective_price |
                                                                        number:'1.0-1'}}/sqft</span> <span class="mrp">
                                                                        <s> MRP &#8377;{{prod?.price |
                                                                            number:'1.0-1'}}/sqft</s></span> <span
                                                                        class="dis">
                                                                        {{prod?.discount}}% off</span> </a>
                                                                
                                                                        <a class="comp-link"
                                                                    *ngIf="!prod?.discount && (prod?.calculation_type === 'meter_wise')">
                                                                    &#8377;<span class="price">{{prod?.price |
                                                                        number:'1.0-1'}}/Meter</span> </a>
                                                                <a class="comp-link"
                                                                    *ngIf="prod?.discount && (prod?.calculation_type === 'meter_wise')">&#8377;
                                                                    <span class="price">{{prod?.effective_price |
                                                                        number:'1.0-1'}}/Meter</span> <span class="mrp">
                                                                        <s> MRP &#8377;{{prod?.price |
                                                                            number:'1.0-1'}}/Meter</s></span> <span
                                                                        class="dis">
                                                                        {{prod?.discount}}% off</span> </a>
                                                                    
                                                            </div>
                                                            <div class="cashback-chip-2" *ngIf="prod.cashback">
                                                                <p> Cashback {{prod?.cashback?.cashback}}%</p>
                                                            </div>
                                                        </li>

                                                        <li class="comp-item" *ngFor="let att of prod?.attribute_list">
                                                            <a class="comp-link">{{att?.value}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="simi-act-btn"
                                                    [ngClass]="{'active-simi-act-btn':prod?.id===productDetail?.id}">
                                                    <a *ngIf="prod?.id===productDetail?.id">Selected option</a>
                                                    <a *ngIf="prod?.id!==productDetail?.id"
                                                        routerLink="../{{prod?.slug_name}}" target="_blank">View
                                                        details</a>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <div class="t-block">
                                <div class="comp-conatiner">
                                    <div class="comp-list" #compList>
                                        <div class="comp-card comp-product-keys">
                                            <div class="comp-img"></div>
                                            <div class="comp-content">
                                                <ul class="comp-list-ul comp-list-ul-bg ">
                                                    <li class="comp-item ">
                                                        <a class="comp-link">Brand</a>
                                                    </li>
                                                    <li class="comp-item ">
                                                        <a class="comp-link">Price</a>
                                                    </li>
                                                    <li class="comp-item " *ngFor="let mat of master_attribute_list">
                                                        <a class="comp-link">{{mat}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="comp-card" *ngFor="let prod of similar_product_list;let pi-index">
                                            <div class="comp-img">
                                                <img ngOptimizedImage loading="lazy" width="400" height="200"
                                                    [ngSrc]="prod?.image_list[0]?.image_url" [alt]="prod?.name"
                                                    *ngIf="prod?.image_list[0]?.image_url">
                                            </div>
                                            <div class="comp-content">
                                                <ul class="comp-list-ul">
                                                    <li class="comp-item">
                                                        <a class="comp-link">{{prod?.brand}} </a>
                                                    </li>
                                                    <li class="comp-item">
                                                        <div *ngIf="prod?.price">
                                                            <a class="comp-link" *ngIf="!prod?.discount"> &#8377;<span
                                                                    class="price">{{prod?.price |
                                                                    number:'1.0-1'}}</span>
                                                            </a>
                                                            <a class="comp-link" *ngIf="prod?.discount">&#8377; <span
                                                                    class="price">{{prod?.effective_price |
                                                                    number:'1.0-1'}}</span>
                                                                <span class="mrp">
                                                                    <s>MRP &#8377; {{prod?.price |
                                                                        number:'1.0-1'}}</s></span> <span class="dis">
                                                                    {{prod?.discount}}% off</span> </a>
                                                        </div>
                                                    </li>

                                                    <li class="comp-item" *ngFor="let att of prod?.attribute_list">
                                                        <a class="comp-link">{{att?.value}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="simi-act-btn"
                                                [ngClass]="{'active-simi-act-btn':prod?.id===productDetail?.id}"
                                                style="margin-right: 5px;">
                                                <a *ngIf="prod?.id===productDetail?.id">Selected option</a>
                                                <a *ngIf="prod?.id!==productDetail?.id"
                                                    routerLink="../{{prod?.slug_name}}" target="_blank">View details</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-block">
                                <div class="comp-conatiner">
                                    <div class="comp-list">
                                        <div class="comp-card comp-product-keys">
                                            <div class="comp-img"></div>
                                            <div class="comp-content">
                                                <ul class="comp-list-ul comp-list-ul-bg ">
                                                    <li class="comp-item ">
                                                        <a class="comp-link">Brand</a>
                                                    </li>
                                                    <li class="comp-item ">
                                                        <a class="comp-link">Price</a>
                                                    </li>
                                                    <li class="comp-item " *ngFor="let mat of master_attribute_list">
                                                        <a class="comp-link">{{mat}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="comp-card" *ngFor="let prod of similar_product_list;let pi-index">
                                            <div class="comp-img">
                                                <img ngOptimizedImage loading="lazy" width="400" height="200"
                                                    [src]="prod?.image_list[0]?.image_url" [alt]="prod?.name"
                                                    *ngIf="prod?.image_list[0]?.image_url">
                                            </div>
                                            <div class="comp-content">
                                                <ul class="comp-list-ul">
                                                    <li class="comp-item">
                                                        <a class="comp-link">{{prod?.brand}} </a>
                                                    </li>
                                                    <li class="comp-item">
                                                        <div *ngIf="prod?.price">
                                                            <a class="comp-link" *ngIf="!prod?.discount"> &#8377;<span
                                                                    class="price">{{prod?.price |
                                                                    number:'1.0-1'}}</span>
                                                            </a>
                                                            <a class="comp-link" *ngIf="prod?.discount">&#8377; <span
                                                                    class="price">{{prod?.effective_price |
                                                                    number:'1.0-1'}}</span>
                                                                <span class="mrp">
                                                                    <s>MRP &#8377; {{prod?.price |
                                                                        number:'1.0-1'}}</s></span> <span class="dis">
                                                                    {{prod?.discount}}% off</span> </a>
                                                        </div>
                                                    </li>
                                                    <ng-container *ngFor="let att of prod?.attribute_list">
                                                        <li class="comp-item" *ngIf="att?.value !== null">
                                                            <a class="comp-link">{{ att?.value }}</a>
                                                        </li>
                                                    </ng-container>
                                                </ul>
                                            </div>
                                            <div class="simi-act-btn"
                                                [ngClass]="{'active-simi-act-btn':prod?.id===productDetail?.id}"
                                                style="margin-right: 5px;">
                                                <a *ngIf="prod?.id===productDetail?.id">Selected option</a>
                                                <a *ngIf="prod?.id!==productDetail?.id"
                                                    routerLink="../{{prod?.slug_name}}" target="_blank">View details</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
              
                <div id="compatible-products" class="row product-detail-container" *ngIf="support_product_list?.length">
                    <div class="col-12 px-0">
                        <div class="section-heading">
                            You May Also Need
                        </div>
                        <div class="section-body pb-0">
                            <div class="compatible-product-list">
                                <ul class="compatible-product-list-ul">
                                    <li class="compatible-product-card"
                                        *ngFor="let prod of support_product_list;let pi-index">
                                        <a [href]="getRdUrl(prod)" target="_blank" [title]="prod?.name">
                                            <div class="compatible-product-img">
                                                <img ngOptimizedImage loading="lazy" width="302" height="256"
                                                    [ngSrc]="prod?.image_list[0]?.image_url" [alt]="prod?.name">
                                            </div>
                                            <div class="compatible-product-text" *ngIf="prod?.product_type">
                                                <div class="compatible-type">
                                                    <a>{{prod?.product_type}} </a>
                                                    <div class="only-web"> <i class="fa fa-angle-right "
                                                            style="font-size: 14px;color: #000;" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                <div class="only-mobile">
                                                    <i class="fa fa-angle-right " style="color: #fff;"
                                                        aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="combination" class="row product-detail-container" *ngIf="product_collection_list?.length">
                    <div class="col-12 px-0">
                        <div class="section-heading">
                            combination
                        </div>
                        <div class="section-body pb-0">
                            <div class="collection-product-list">
                                <ul class="collection-product-list-ul">
                                    <li class="collection-product-card"
                                        *ngFor="let prod of product_collection_list;let pi-index">
                                        <div class="collection-product-card-a">
                                            <div class="collection-product-img">
                                                <img ngOptimizedImage loading="lazy" width="267" height="242" 
                                                    [ngSrc]="prod?.image_list[0]?.image_url" [alt]="prod?.name">
                                            </div>
                                            <div class="collection-product-text">
                                                <div>
                                                    <div class="coll-brand">
                                                        {{prod?.brand}}
                                                    </div>
                                                    <div class="coll-class">
                                                        {{prod?.product_class}}
                                                    </div>
                                                    <div class="coll-name">
                                                        {{prod?.name}}
                                                    </div>
                                                    <div class="coll-price-d" *ngIf="!prod?.discount && prod?.price">
                                                        <span class="mob-pric">Price:</span> <span style="font-size: 12px;">
                                                            &#8377;
                                                        </span>{{prod?.price | number:'1.0-1'}}
                                                    </div>
                                                    <div class="coll-price-d" *ngIf="prod?.discount&& prod?.price">&#8377;
                                                        {{prod?.effective_price | number:'1.0-1'}}<span class="mrp"> MRP
                                                            <s>{{prod?.price | number:'1.0-1'}}</s></span> <span
                                                            class="dis">{{prod?.discount}}%</span></div>
                                                    <div class="cashback-chip-2" *ngIf="prod.cashback">
                                                        <p> Cashback {{prod?.cashback?.cashback}}%</p>
                                                    </div>
                                                    <div class="collection-description w-block" *ngIf="prod?.description">
                                                        <app-read-more class="prodReadMore" [text]="prod?.description"
                                                            [maxLength]="180">
                                                        </app-read-more>
                                                    </div>
                                                    <div class="view-all-btn">
                                                        <a routerLink="../{{prod?.slug_name}}" target="_blank"
                                                            [title]="prod?.name">View detail</a>
                                                    </div>
                                                </div>
                                                <div class="only-web collection-product-card-action">
                                                    <button class="save-idea" (click)="addProductSpace(productDetail)"
                                                        *ngIf="!prod?.is_already_selected">
                                                        Save idea
                                                    </button>
    
                                                    <button class="add-to-cart" (click)="addToCart(productDetail)"
                                                        *ngIf="!prod?.is_already_selected">
                                                        Add to list
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="customer-review product-detail-container " id="customer-review" *ngIf="productDetail?.questions_answers?.length > 0">
                    <div class="section-heading ng-tns-c136-27"> Customer Reviews </div>

                    <div class="review-card" *ngFor="let comment of this.user_comments">
                        <div class="review-header">
                          <img *ngIf="comment.user_detail.image; else defaultAvatar" [src]="comment.user_detail.image" class="user-avatar" />
                          <ng-template #defaultAvatar>
                            <div class="profile-img">
                                {{ getInitials(comment.user_detail.name, comment.user_detail.last_name) }}
                            </div>
                            
                          </ng-template>
                          <div>
                            <p class="professional_type">{{comment.user_detail.profession_type}} <span class="verified">Verified</span></p>
                            <h4 class="username">{{ comment.user_detail.name }} {{ comment.user_detail.last_name }} </h4>
                            <a class="busnisename" routerLink="../../service-provider/{{comment.user_detail.slug_name}}">{{comment.user_detail.business_name}}</a>
                           
                          </div>
                        </div>
                        <div class="star-sec">
                            <p-rating [(ngModel)]="comment.stars" [readonly]="true" [cancel]="false" class="star-rating"></p-rating>
                        </div>
                        <p class="review-content">
                          {{ comment.comment }}
                        </p>
                    </div>
                    <div header="Customer Reviews"  class="reviews-section" *ngIf="productDetail?.questions_answers">
                        <div *ngIf="productDetail?.questions_answers?.length > 0" class="question-list">
                            <div *ngFor="let q of productDetail?.questions_answers" class="question-item">
                              <!-- Question Title -->
                              <h4>{{ q.question_text }}</h4>
                              <!-- Answer Choices with Customer Selections -->
                              <div class="answer-options">
                                <div *ngFor="let a of q.answers" class="answer-bar">
                                  <!-- <span class="answer-text">{{ a.answer_response }}</span>
                                  <div class="progress-container">
                                    <div class="progress-bar" [ngStyle]="{ width: getPercentage(a.answer_count) + '%' }"></div>
                                  </div> -->
                                  
                                  <div class="rating-container">
                                    <!-- <div class="circle-progress">
                                        <svg viewBox="0 0 36 36" class="circular-chart">
                                          <path class="circle-bg" d="M18 2.0845
                                              a 15.9155 15.9155 0 0 1 0 31.831
                                              a 15.9155 15.9155 0 0 1 0 -31.831" />
                                          <path class="circle" [attr.stroke-dasharray]="getStrokeDasharray(a.average_selection)" />
                                        </svg>
                                        <span class="rating-value">{{ getPercentage(a.answer_count) }}</span>
                                      </div> -->
                                      <p-knob [(ngModel)]="a.average_selection" [size]="50" valueColor="MediumTurquoise"   [min]="0" [max]="100" />
                                      
                                    <div class="rating-label">{{ a.answer_response }}</div>
                                    <span class="answer-count">{{ a.answer_count }} Customers</span>
                                  </div>
                                  
                                </div>
                              </div>
                      
                            </div>
                          </div>
                        <p *ngIf="!productDetail?.questions_answers?.length">No reviews yet.</p>
                    </div>
                </div>
                <div id="recently-viewed" class="product-container bg-white"
                    *ngIf="recentlyViewedProducts?.length && !global_loader">
                    <div class="product-sub-category product-detail-container">
                        <div class="section-heading recently-border-none-mob">
                            recently viewed
                        </div>
                        <div class="product-list">
                            <ul>
                                <li class="recently-viewed-product-card"
                                    *ngFor="let prod of recentlyViewedProducts;let pi-index">
                                    <a routerLink="../{{prod?.slug_name}}" target="_blank" [title]="prod?.name">
                                        <div class="product-img">
                                            <img ngOptimizedImage loading="lazy" [src]="prod?.image_list[0]?.image_url"
                                                [alt]="prod?.name">
                                        </div>
                                        <div class="product-text">
                                            <div class="brand-text-over-flow-hidden">
                                                <p>{{prod?.brand}}</p>
                                                <div class="view-count" *ngIf="prod?.view_count">
                                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                                    {{prod?.view_count | number:'1.0-1'}}
                                                </div>
                                            </div>
                                            <div class="name text-over-flow-hidden">
                                                {{prod?.name}}
                                            </div>
                                            <div *ngIf="prod?.price">
                                                <div class="price"
                                                    *ngIf="!prod?.discount && (prod?.calculation_type !=='sqft_wise' && prod?.calculation_type !=='sheet_wise')">
                                                    <span class="mob-pric">Price:</span>
                                                    <div class="rup-sig">&#8377;</div> {{prod?.price | number:'1.0-1'}}
                                                </div>
                                                <div class="price"
                                                    *ngIf="prod?.discount && (prod?.calculation_type !=='sqft_wise' && prod?.calculation_type !=='sheet_wise')">
                                                    <span class="mob-pric">Price:</span>
                                                    <div class="rup-sig">&#8377;</div> {{prod?.effective_price |
                                                    number:'1.0-1'}}
                                                </div>
                                                <div class="discount-pr"
                                                    *ngIf="prod?.discount && (prod?.calculation_type !=='sqft_wise' && prod?.calculation_type !=='sheet_wise')">
                                                    <s style="color: #222 !important;">MRP &#8377;{{prod?.price
                                                        | number:'1.0-1'}}</s> <span
                                                        class="dis-off mt-0">{{prod?.discount}}% off</span>
                                                </div>
                                                <div class="price" style="text-transform: lowercase;"
                                                    *ngIf="!prod?.discount && (prod?.calculation_type ==='sqft_wise' || prod?.calculation_type ==='sheet_wise')">
                                                    <span class="mob-pric">Price:</span>
                                                    <div class="rup-sig">&#8377;</div>{{prod?.price |
                                                    number:'1.0-1'}}/sqft
                                                </div>
                                                <div class="price" style="text-transform: lowercase;"
                                                    *ngIf="prod?.discount && (prod?.calculation_type ==='sqft_wise' || prod?.calculation_type ==='sheet_wise')">
                                                    <span class="mob-pric">Price:</span>
                                                    <div class="rup-sig">&#8377;</div>{{prod?.effective_price |
                                                    number:'1.0-1'}}/sqft
                                                </div>
                                                <div class="discount-pr"
                                                    *ngIf="prod?.discount && (prod?.calculation_type ==='sqft_wise' || prod?.calculation_type ==='sheet_wise')">

                                                    <s style="color: #222 !important;text-transform: lowercase;">MRP
                                                        &#8377;{{prod?.price
                                                        | number:'1.0-1'}}/sqft</s> <span
                                                        class="dis-off mt-0">{{prod?.discount}}% off</span>
                                                </div>
                                                <div class="cashback-chip" *ngIf="prod?.cashback">
                                                    <p> Cashback {{prod?.cashback?.cashback}}%</p>
                                                </div>
                                            </div>
                                            <div class="price-msg">
                                                Get best price offer*
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- <div id="nearby-sallers" class="row product-detail-container" *ngIf="nearbyDealers.length">
                    <div class="col-12 px-0">
                        <div class="section-heading">
                            near by seller
                        </div>
                        <div class="section-body pb-0">
                            <div class="saller-container">
                                <ul class="saller-ul">
                                    <li *ngFor="let dealer of nearbyDealers;let di=index">
                                        <a class="dealer-card-outer" routerLink="../../dealer/{{dealer?.slug_name}}" [title]="dealer?.showroom_name">
                                            <div class="dealer-card home-card card-r-gap">
                                                <div class="connect-form"
                                                    *ngIf="isConnectDealer && selectedDealerIndex===di">
                                                    <div>
                                                        <p>When would you like <br> to make purchase?</p>
                                                        <div class="d-flex m-auto" style="width: fit-content;">
                                                            <button type="button" class="buy-btn"
                                                                (click)="connectDealerTopffer('No');$event.stopPropagation()">Later</button>
                                                            <button type="button" class="buy-btn"
                                                                (click)="connectDealerTopffer('Yes');$event.stopPropagation()">Now</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="dealer-shoowroom-img">
                                                    <img  ngOptimizedImage loading="lazy" width="447" height="279"  [ngSrc]="dealer?.showroom_image_list[0]?.showroom_image_url"
                                                        [alt]="dealer?.showroom_name">
                                                </div>
                                                <div class="dealer-content">
                                                    <div class="name-and-distance-strip">
                                                        <span class="card-name">{{dealer?.showroom_name}}</span>
                                                        <div class="distance">
                                                            <img  ngOptimizedImage loading="lazy"  src="https://res.cloudinary.com/afterbricks/image/upload/v1667300836/unnamed_pgkys1.png"
                                                                alt="{{dealer?.km}}">
                                                            <div>{{dealer?.km | number : '1.2-2'}} KM</div>
                                                        </div>
                                                    </div>
    
                                                    <p><span>{{dealer?.address2}} ,</span> {{dealer?.city}} </p>
                                                    <div class="d-offer" *ngIf="dealer?.discount && dealer?.is_connect">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                            viewBox="0 0 13 13">
                                                            <path fill="#54BD8A" fill-rule="nonzero"
                                                                d="M12.125 5.518l-.461-.687a.536.536 0 0 1-.053-.25l.053-.832a1.171 1.171 0 0 0-.647-1.122l-.739-.37a.361.361 0 0 1-.171-.171l-.383-.766A1.183 1.183 0 0 0 8.603.673L7.77.726A.382.382 0 0 1 7.534.66L6.82.198a1.176 1.176 0 0 0-1.306 0L4.83.66a.629.629 0 0 1-.264.053L3.734.66a1.237 1.237 0 0 0-1.135.66l-.37.74a.361.361 0 0 1-.17.17l-.74.37c-.422.212-.672.66-.646 1.122l.053.832c0 .08-.014.172-.066.238l-.462.712c-.264.396-.264.911 0 1.307l.462.687a.63.63 0 0 1 .052.264l-.052.831c-.013.476.237.911.66 1.136l.738.37c.08.039.132.105.172.17l.37.74c.21.422.659.673 1.12.647l.832-.053c.08 0 .172.013.237.066l.687.449c.197.132.422.198.646.198.224 0 .449-.066.647-.198l.686-.462a.494.494 0 0 1 .237-.066l.831.053a1.17 1.17 0 0 0 1.122-.647l.37-.74a.361.361 0 0 1 .17-.171l.74-.37c.422-.21.673-.66.646-1.122l-.026-.818c0-.08.013-.172.066-.238l.448-.7c.33-.422.33-.937.066-1.32zM3.952 3.265c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25c-.702 0-1.25-.549-1.25-1.25 0-.689.561-1.25 1.25-1.25zm.103 5.674a.378.378 0 0 1-.263.11c-.083 0-.161-.229-.244-.298a.344.344 0 0 1 0-.512l4.674-4.674a.344.344 0 0 1 .512 0c.138.152.12.562-.032.7L4.055 8.939zm3.897.685c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25c.701 0 1.25.549 1.25 1.25 0 .689-.561 1.25-1.25 1.25z">
                                                            </path>
                                                        </svg>
                                                        <span> available {{dealer?.discount | number:'1.0-1'}}% discount
                                                            selected product</span>
                                                    </div>
                                                    <div class="d-offer" *ngIf="!dealer?.discount && dealer?.is_connect">
    
                                                        <span style="color:#112d00;;">No discount is available here</span>
                                                    </div>
                                                   
                                                    <div class="brand-auth">
                                                        <span>Get this Month Offer for</span>
                                                        <ul>
                                                            <li [ngClass]="{'d-none':(bri+1) >= 6}"
                                                                *ngFor="let br of dealer?.brands;let bri=index">
                                                                <div class="br-card">
                                                                    <img  ngOptimizedImage loading="lazy" width="40" height="40" [src]="br?.logo" [alt]="br?.name">
                                                                </div>
                                                            </li>
                                                            <li class="d-flex" *ngIf="(dealer?.brands?.length >= 6)">
                                                                <span
                                                                    style="color: #06c;font-size: 10px;font-family:'SF UI Text Regular';margin-bottom: 3px;">{{dealer?.brands?.length
                                                                    - 6}} more</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
    
                            </div>
                        </div>
                    </div>
                </div> -->
                <!--------------------loader------------------------->
                <!-- <div class="product-container bg-white is-loading" *ngIf="global_loader">
                <div class="product-sub-category product-detail-container">
                    <div class="recently-viewed-heading name" style="height: 35px;margin-bottom: 18px;"> </div>
                    <div class="product-list">
                        <ul>
                            <li class="recently-viewed-product-card" *ngFor="let prod of [1,2,3,4,5,6]">
                                <a target="_blank">
                                    <div class="product-img product-img-1"></div>
                                    <div class="product-text">
                                        <div class="brand-text-over-flow-hidden">
                                            <p class="brand"></p>
                                            <div class="view-count"></div>
                                        </div>
                                        <div class="name text-over-flow-hidden">
                                        </div>
                                        <div class="price"></div>
                                        <div class="price-msg">
                                        </div>
                                        <div class="price-msg name">
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
                <!----------------end loader-------------------------------->
                <!--------------- Questions & Answers -------------------->
                <div id="questions-answers" class="product-detail-container" *ngIf="!_as.isProduction">
                    <div class="section-heading">
                        <p  >questions & answers</p>
                    </div>
                    <div class="q-a-text">
                        <div>
                            <div class="q-a-text-qustion">Q: “Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Feugiat
                                quam scelerisque pharetra sed?” asked by Steven</div>
                            <div class="q-a-text-ans">A: “Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Feugiat
                                quam
                                scelerisque pharetra sed. Feugiat quam scelerisque pharetra sed.</div>
                        </div>
                        <div class="help">
                            <button>help</button>
                        </div>
                    </div>
                    <div class="q-a-text">
                        <div>
                            <div class="q-a-text-qustion">Q: “Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Feugiat
                                quam scelerisque pharetra sed?” asked by Steven</div>
                            <div class="q-a-text-ans">A: “Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Feugiat
                                quam
                                scelerisque pharetra sed. Feugiat quam scelerisque pharetra sed.</div>
                        </div>
                        <div class="help">
                            <button>help</button>
                        </div>
                    </div>
                    <div class="q-a-text">
                        <div>
                            <div class="q-a-text-qustion">Q: “Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Feugiat
                                quam scelerisque pharetra sed?” asked by Steven</div>
                            <div class="q-a-text-ans">A: “Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Feugiat
                                quam
                                scelerisque pharetra sed. Feugiat quam scelerisque pharetra sed.</div>
                        </div>
                        <div class="help">
                            <button>help</button>
                        </div>
                    </div>
                    <a class="q-a-link ">See all Questions & Answers</a>
                    <div class="w-block border-q-a"></div>
                </div>
                <!--------------- End Questions & Answers -------------------->


                <!--------------- Shipping & Returns -------------------->
                <div id="shipping-returns" class="product-detail-container " *ngIf="!_as.isProduction">
                    <div class="section-heading">
                        <p  >shipping & returns</p>
                    </div>
                    <div class="row">
                        <div class="shipping">
                            <div class="col-md-4 col-sm-6 ">
                                <div class="shipping-card">
                                    <div class="shipping-img-one">
                                        <img ngOptimizedImage loading="lazy"
                                            src="https://res.cloudinary.com/afterbricks/image/upload/v1652518072/Vector_2_bzk8ei.png"
                                            alt="">
                                        <div class="shipping-text">
                                            <span>Free Fast Delivery</span>
                                        </div>
                                    </div>
                                    <div class="shipping-fast-text">
                                        <p>Ships via: <a>Fast Delivery</a></p>
                                        <p>Ship To: <a>{{_as.user_location?.pincode}} -
                                                {{_as.user_location?.locality}},
                                                {{_as.user_location?.city}}</a></p>
                                    </div>
                                    <div class="shipping-date-text">
                                        <h3>Fast Delivery</h3>
                                        <p>Estimated Delivery: {{afterFiveDayDate | date:'EEEE d MMMM y'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-6">
                                <div class="shipping-card">
                                    <div class="shipping-img-card">
                                        <div class="shipping-img-two">
                                        </div>
                                        <img ngOptimizedImage loading="lazy"
                                            src="https://res.cloudinary.com/afterbricks/image/upload/v1652519021/Group_5_efbgxv.png"
                                            alt="">
                                    </div>
                                    <div class="shipping-text">
                                        <h4>Shipping</h4>
                                        <p>Your order means a lot to us. That’s why
                                            we offer fast, safe and reliable delivery
                                            options for every item.</p>
                                        <a>Shipping Policy</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-6">
                                <div class="shipping-card">
                                    <div class="shipping-img-card">
                                        <div class="shipping-img-two"></div>
                                        <img ngOptimizedImage loading="lazy"
                                            src="https://res.cloudinary.com/afterbricks/image/upload/v1652518931/Vector_3_bxvvhj.png"
                                            alt="">
                                    </div>
                                    <div class="shipping-text">
                                        <h4>30-Day Return</h4>
                                        <p>Not loving it? We offer returns for most
                                            items within 30 days of delivery for a
                                            refund or store credit.</p>
                                        <a> 30-Day Return Policy</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!---------------  Related Searches -------------------->
            </div>
        </div>
        
        
        <!-- (click)="shownearbyDealers()" -->
        <!-- <div class="nearby-showroom-btn" (mouseenter)="shownearbyDealers()"  *ngIf="this.nearbyDealers.length">
            <button >Near By Seller</button>
        </div> -->
        <div class="m-block">
            <div class="ab-footer-menu">
                <div class="save-btn-and-link">
                    <button class="save-idea-btn " [ngClass]="{'full-w-save-idea-btn':!_cart.is_my_list}"
                        *ngIf="!is_addToCart && !is_prospect && !productDetail?.is_already_selected"
                        (click)="addProductSpace(productDetail)" style="border-radius: 0px;">
                        <svg width="17" height="18" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style="margin-right:7px;">
                            <path
                                d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                                fill="#fc9918" />
                        </svg>
                        SAVE IDEA
                    </button>
                    <button class="addtolistbtn-save-idea" *ngIf="(!is_addToCart && _cart.is_my_list)"
                        (click)="addToCart(productDetail)">
                        <img ngOptimizedImage loading="lazy" style="margin-right: 17px; height: 15px;"
                            src="https://res.cloudinary.com/afterbricks/image/upload/v1653118651/icons/Group_o4awyd.svg"
                            alt="add-cart">
                        ADD TO CART
                    </button>
                    <button class="ab-footer-mob-lig-btn alr-sele-btn mr-2" *ngIf="is_addToCart"
                        (click)="onBackProductPage()"> <i class="fa-solid fa-caret-left" style="font-size: 13px;"></i>
                        PRODUCTS</button>

                    <button class="ab-footer-mob-btn" *ngIf="is_addToCart && _cart.is_my_list"
                        (click)="goToProductDetail()">MY LIST</button>

                    <button class="ab-footer-mob-lig-btn alr-sele-btn"
                        *ngIf="productDetail?.is_already_selected && !is_addToCart" (click)="goToSaveIdea()">ALREADY
                        SELECTED
                    </button>
                </div>
            </div>
        </div>
        <!-----------------------Spaces popup------------------------------------->
        <div class="add-product-spaces-popoup popup-1" *ngIf="!isOnMobilePlatform">
            <p-dialog [(visible)]="productDetailChild.visibleSpaceTag" [showHeader]="false" [modal]="true"
                [transitionOptions]="_pop.dialogTransitionTime" [dismissableMask]="_pop.closeOutside"
                [baseZIndex]="100000">
                <div class="add-product-popup-body">
                    <div class="add-product-popup-heading">
                        <div>
                            <h3 *ngIf="product_add_action !=='addToCart'">
                                <img ngOptimizedImage loading="lazy"
                                    src="https://res.cloudinary.com/afterbricks/image/upload/v1685433709/heart_1_h5rut5.png"
                                    alt="">
                                Save idea to collection
                            </h3>
                            <h3 *ngIf="product_add_action ==='addToCart'">Add To cart</h3>
                            <div class="row all-space-add-space">
                                <div class="tag-all-space-strip ">
                                    <p>You like it for which all spaces?</p>
                                    <div class="position-relative">
                                        <p-checkbox label="All Spaces" [(ngModel)]="main_space_select_all_flag"
                                            value="main_space_select_all_flag"
                                            (onChange)="onSelecteAllSpace(main_space_select_all_flag)" [binary]="true"
                                            [ngClass]="{'MMainSubCateGoryActive':main_space_select_all_flag}">
                                        </p-checkbox>
                                        <div  class="checked-svg"  [ngClass]="{'active-checked-svg':main_space_select_all_flag}">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                                <path
                                                    d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                                    fill="white" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-product-spaces-popoup-product p-0">
                            <div class="active-product-card">
                                <img ngOptimizedImage loading="lazy" [src]="tagged_product?.image_list[0].image" alt="">
                            </div>
                            <p class="brand-name">{{tagged_product?.brand_name}}</p>
                        </div>
                    </div>
                    <div class="add-product-spaces-popoup-body" [ngClass]="{'on-change-opacity':isSelectProduct}">


                        <!-- """"""""""""""""""""""" Space Container "'""""""""""""""""""""""""""""-->
                        <div class="add-product-spaces-popoup-space">
                            <div class="row">
                                <div class=" datacheckboxing">
                                    <p-scrollPanel styleClass="spaces-scroller">
                                        <div class="row space-list" *ngFor="let ms of main_space_list; let msi=index">
                                            <div class="col-12 row px-0" style="padding: 0 15px !important;">
                                                <p class="p-100-px main-space-name " style="color: #004299;">
                                                    <img ngOptimizedImage loading="lazy"
                                                        [src]="ms.sub_space_list[0].icon" alt=""> {{ms.name}} <button
                                                        class="add-more-btn" (click)="redirectToSelectSpace(ms.mId)">
                                                        <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                                                        spaces</button>
                                                </p>
                                                <div class="d-flex sub-space-popup ml-2">
                                                    <div class="main-space-popup" *ngIf="ms.sub_space_list.length > 1">
                                                        <p-checkbox label="All" [(ngModel)]="ms.is_selected"
                                                            value="ms.is_selected" [binary]="true"
                                                            (onChange)="onTagAllSubSpace(ms.is_selected,msi)"
                                                            [ngClass]="{'MMainSubCateGoryActive':ms.is_selected}"
                                                            *ngIf="ms.sub_space_list.length > 1">
                                                        </p-checkbox>
                                                        <div  class="checked-svg" [ngClass]="{'active-checked-svg':ms.is_selected}">
                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                                                <path
                                                                    d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                                                    fill="white" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div class="position-relative"
                                                        *ngFor="let ss of ms.sub_space_list;let ssi=index">
                                                        <div class="check-box-card"
                                                            [ngClass]="{'active-check-box-card':ss.is_selected}">
                                                            <input type="checkbox" [(ngModel)]="ss.is_selected"
                                                                    (change)="onAddProductToSpace(ss.id,ss.is_selected,msi,ssi)"
                                                                    [value]="ss.is_selected" [id]="ss.id" />
                                                            <label [for]="ss?.id">
                                                                <span>
                                                                    {{ss.name}}
                                                                </span>
                                                                <div class="added-btn" *ngIf="ss.tagged_products.length"
                                                                    (mouseover)="onHoverSpace(ss.id)"
                                                                    (mouseleave)="onHoverSpace(undefined)">
                                                                    <div class="products-in-space"
                                                                        [ngClass]="{'activer-pis':ss.id===activerSpaceID,'products-in-space-more-then-3':ss.tagged_products.length > 3}">
                                                                        <div
                                                                            *ngFor="let sp of ss.tagged_products;let spi=index;">
                                                                            <div class="product-spi-list">
                                                                                <div class="product-spi-image d-none"
                                                                                    [ngClass]="{'current-product-spi-image':sp.id === temp_product_id}">
                                                                                    <img ngOptimizedImage loading="lazy"
                                                                                        [src]="sp.image_list[0].image"
                                                                                        [alt]="sp.name">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="checked-svg"  [ngClass]="{'active-checked-svg':ss.is_selected}">
                                                                    <svg width="14" height="14" viewBox="0 0 14 14"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                                                        <path
                                                                            d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                                                            fill="white" />
                                                                    </svg>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </p-scrollPanel>
                                </div>
                            </div>
                        </div>
                        <!-- """"""""""""""""""""""" End space Container "'""""""""""""""""""""""""""""-->
                    </div>
                </div>
                <div class="add-product-spaces-popoup-footer" [ngClass]="{'on-change-opacity':isSelectProduct}">
                    <p> <a class="collection-btn" (click)="space_review()">See Collection</a>  {{currSubCatName}}
                    </p>
                    <button class="btn btn-light cancel-bttn" (click)="oncloseAddPro(true)"
                        *ngIf="!tagged_in_spaces_count">Cancel</button>
                    <button class="btn done-btn popup-save-btn" (click)="oncloseAddPro(true)"
                        *ngIf="tagged_in_spaces_count">
                        <!-- <svg width="18" height="17" viewBox="0 0 19 17" fill="none" style=" margin-right: 8px;"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                            fill="#fc9918" />
                    </svg> -->
                        Save idea
                    </button>
                </div>
                <div class="save-idea-sub-bg">
                    <img ngOptimizedImage loading="lazy" src="assets/images/bg/save-idea--popup-bg.jpg">
                </div>
            </p-dialog>
        </div>
        <div class="add-product-spaces-popoup m-block" *ngIf="isOnMobilePlatform">
            <p-sidebar [(visible)]="productDetailChild.visibleSpaceTag" position="bottom" [baseZIndex]="10000"
                [showCloseIcon]="false" [blockScroll]="true">
                <div class="add-product-popup-body">

                    <div class="close-add-space" (click)="oncloseAddPro(true)">
                        <img ngOptimizedImage loading="lazy"
                            src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg"
                            alt="">
                    </div>
                    <div class="add-product-popup-heading">
                        <div>
                            <h3 *ngIf="product_add_action !=='addToCart'">Save idea to collection</h3>
                            <h3 *ngIf="product_add_action ==='addToCart'">Add To cart</h3>
                            <div class="row all-space-add-space">
                                <div class="tag-all-space-strip">
                                    <p>You like it for which all spaces?</p>
                                    <div class="d-flex align-items-center position-relative mt-2">
                                        <p-checkbox label="All Spaces" [(ngModel)]="main_space_select_all_flag"
                                            value="main_space_select_all_flag"
                                            (onChange)="onSelecteAllSpace(main_space_select_all_flag)" [binary]="true"
                                            [ngClass]="{'MMainSubCateGoryActive':main_space_select_all_flag}">
                                        </p-checkbox>
                                        <div class="checked-svg" [ngClass]="{'active-checked-svg':main_space_select_all_flag}">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                                <path
                                                    d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                                    fill="white" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-product-spaces-popoup-product p-0">
                        <div class="active-product-card">
                            <img ngOptimizedImage loading="lazy" [src]="tagged_product?.image_list[0].image" alt="">
                        </div>
                        <p class="brand-name">{{tagged_product?.brand_name}}</p>
                    </div>
                    <div class="add-product-spaces-popoup-body" [ngClass]="{'on-change-opacity':isSelectProduct}">


                        <!-- """"""""""""""""""""""" Space Container "'""""""""""""""""""""""""""""-->
                        <div class="add-product-spaces-popoup-space">
                            <div class="row">
                                <div class=" datacheckboxing">
                                    <p-scrollPanel styleClass="spaces-scroller">
                                        <div class="row space-list" *ngFor="let ms of main_space_list; let msi=index">
                                            <div class="col-12 row px-0 ">
                                                <p class="p-100-px main-space-name" style="color: #004299;">
                                                    <img ngOptimizedImage loading="lazy"
                                                        [src]="ms.sub_space_list[0].icon" alt=""> {{ms.name}} <button
                                                        class="add-more-btn" (click)="redirectToSelectSpace(ms?.mId)">
                                                        <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                                                        spaces</button>
                                                </p>
                                                <div class="d-flex sub-space-popup">
                                                    <div class="main-space-popup" *ngIf="ms.sub_space_list.length > 1">
                                                        <p-checkbox label="All" [(ngModel)]="ms.is_selected"
                                                            value="ms.is_selected" [binary]="true"
                                                            (onChange)="onTagAllSubSpace(ms.is_selected,msi)"
                                                            [ngClass]="{'MMainSubCateGoryActive':ms.is_selected}"
                                                            *ngIf="ms.sub_space_list.length > 1">
                                                        </p-checkbox>
                                                        <div  class="checked-svg" [ngClass]="{'active-checked-svg':ms.is_selected}">
                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                                                <path
                                                                    d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                                                    fill="white" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div class="position-relative"
                                                        *ngFor="let ss of ms.sub_space_list;let ssi=index">
                                                        <div class="check-box-card"
                                                            [ngClass]="{'active-check-box-card':ss.is_selected}">
                                                            <input type="checkbox" [(ngModel)]="ss.is_selected"
                                                            (change)="onAddProductToSpace(ss.id,ss.is_selected,msi,ssi)"
                                                            [value]="ss.is_selected" [id]="ss.id" />
                                                            <label [for]="ss?.id">
                                                                <span>
                                                                    {{ss.name}}
                                                                </span>
                                                                <div class="added-btn" *ngIf="ss.tagged_products.length"
                                                                    (mouseover)="onHoverSpace(ss.id)"
                                                                    (mouseleave)="onHoverSpace(undefined)">
                                                                    <div class="products-in-space"
                                                                        [ngClass]="{'activer-pis':ss.id===activerSpaceID,'products-in-space-more-then-3':ss.tagged_products.length > 3}">
                                                                        <div
                                                                            *ngFor="let sp of ss.tagged_products;let spi=index;">
                                                                            <div class="product-spi-list">
                                                                                <div class="product-spi-image"
                                                                                    [ngClass]="{'current-product-spi-image':sp.id === temp_product_id}">
                                                                                    <img ngOptimizedImage loading="lazy"
                                                                                        [src]="sp.image_list[0].image"
                                                                                        [alt]="sp.name">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                               
                                                                <div class="checked-svg"  [ngClass]="{'active-checked-svg':ss.is_selected}">
                                                                    <svg width="14" height="14" viewBox="0 0 14 14"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                                                        <path
                                                                            d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                                                            fill="white" />
                                                                    </svg>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </p-scrollPanel>
                                </div>
                            </div>
                        </div>
                        <!-- """"""""""""""""""""""" End space Container "'""""""""""""""""""""""""""""-->
                    </div>
                </div>
                <div class="add-product-spaces-popoup-footer" [ngClass]="{'on-change-opacity':isSelectProduct}">
                    <a class="collection-btn" (click)="space_review()">See Collection</a>
                    <button class="btn btn-light cancel-bttn" (click)="oncloseAddPro(true)"
                        *ngIf="!tagged_in_spaces_count">Cancel</button>
                    <button class="btn done-btn done-btn-mob hover"
                        (click)="oncloseAddPro(true)" *ngIf="tagged_in_spaces_count">
                        <i *ngIf="isCloseAddSpace" style="font-size: 15px;"
                            class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
                        <!-- <svg width="17" height="18" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style="margin-right: 6px;">
                            <path
                                d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                                fill="#fc9918" />
                        </svg> -->
                        Save idea
                    </button>
                </div>
                <div class="save-idea-sub-bg">
                    <img ngOptimizedImage loading="lazy" src="assets/images/bg/save-idea--popup-bg.jpg">
                </div>
            </p-sidebar>
        </div>
        <!-- (click)="hideNearbySlider() -->
        <div class="near-by-dealer-slider"(mouseleave)="hideNearbySlider()">
            <p-sidebar [(visible)]="diplayNearbydealer" position="right" [modal]="false">
                <div class="nearby-box">
                    <!-- (mouseleave)="hideNearbySlider()"  -->
                    <div class="close-btn" (click)="hideNearbySlider()">
                        <img ngOptimizedImage loading="lazy" src="assets/images/project/congratssearch.png"
                            alt="close near by">
                    </div>
                    <div class="nearby-dealer-box">
                        <h5 *ngIf="nearbyDealers.length">Showrooms</h5>
                        <ul *ngIf="nearbyDealers.length">
                            <li [ngClass]="{'d-none':(i >= 2)}" [title]="dealer?.showroom_name"
                                *ngFor="let dealer of nearbyDealers;let i=index">
                                <!-- (click)="onNearByDealerClick()" -->
                                <div class="nearby-card" routerLink="../../dealer/{{dealer?.slug_name}}" [title]="dealer?.showroom_name">
                                    <div class="near-by-photo">
                                        <img ngOptimizedImage loading="lazy"
                                            [src]="dealer?.showroom_image_list[0]?.showroom_image_url"
                                            [alt]="dealer?.showroom_name">
                                    </div>
                                    <div class="near-by-content">
                                        <span>{{dealer?.showroom_name}}</span>
                                        <div class="dist-card">
                                            <img ngOptimizedImage loading="lazy"
                                                src="https://res.cloudinary.com/afterbricks/image/upload/v1667300836/unnamed_pgkys1.png"
                                                alt="{{dealer?.km}}">
                                            <div>{{dealer?.km | number : '1.2-2'}} KM</div>
                                        </div>
                                        <span>{{dealer?.address2}}<br> {{dealer?.city}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="row" *ngIf="!nearbyDealers.length">
                            <div class="no-nearbyDealers">
                                <img ngOptimizedImage loading="lazy"
                                    src="https://res.cloudinary.com/afterbricks/image/upload/v1705581864/icons/shop_jghebs.png">
                            </div>
                            <h5 style="color: #ad1818">Oops!</h5>
                            <div class="col-12">
                                <p style="color: #222;font-family: 'SF UI Text Medium';font-size: 14px;">Afterbricks
                                    is not available in your location at the moment. <br>
                                    Right now we are operational in <span style="font-family: 'SF UI Text Bold';">Delhi
                                        NCR</span> only.<br> Please select a different location.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </p-sidebar>
        </div>

        <div class="adqty-mobile" *ngIf="isOnMobilePlatform">
            <p-sidebar [(visible)]="visibleAddqty" position="bottom">
                <div style="padding-bottom: 60px;">
                    <div class="adqty-header">
                        <div class="image">
                            <img ngOptimizedImage loading="lazy" [src]="productDetail?.image_list[0]?.image"
                                [alt]="productDetail?.name">
                        </div>
                        <div class="name">
                            <h3>{{productDetail?.name}}</h3>
                            <p *ngIf="!productDetail?.discount" class="po-ru">&#8377;{{productDetail?.price |
                                number:'1.0-1'}}<span>{{getUnitType(productDetail?.calculation_type)}}</span></p>
                            <p *ngIf="productDetail?.discount" class="po-ru">&#8377;{{productDetail?.price |
                                number:'1.0-1'}} <span>{{getUnitType(productDetail?.calculation_type)}}</span> </p>
                            <p  ><span class="pp po-mrp-ru"
                                    style="margin-top: 0px;margin-left: 0px;font-size: 12px !important;"> <s>MRP
                                        &#8377;{{productDetail?.price |
                                        number:'1.0-1'}} {{getUnitType(productDetail?.calculation_type)}}</s></span>
                                <span class="dis-off" style="margin-left: 4px !important;"> {{productDetail?.discount}}%
                                    off</span></p>
                            <p class="taxes">{{_as.price_help_text}}</p>
                        </div>
                    </div>
                    <div *ngIf="productDetail?.price">
                        <div class="price-offer" *ngIf="productDetail?.calculation_type ==='sqft_wise'">
                            <ul class="pbul">
                                <li>
                                    <div class="perb">
                                        <p>Size: </p>
                                        <p>
                                            {{productDetail?.width | number:'1.2-2'}} ft X {{productDetail?.height |
                                            number:'1.2-2'}} ft / Pc
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <div class="perb">
                                        <p>Quantity: </p>
                                        <p>{{productDetail?.in_box}} Pcs / Box</p>

                                    </div>
                                </li>
                                <li>
                                    <div class="perb">
                                        <p>Coverage Area </p>
                                        <p>{{productDetail?.covered_area_par_box | number:'1.2-2'}} sqft / Box</p>

                                    </div>
                                </li>
                            </ul>

                            <div class="sqft-calculator">
                                <div class="sqft-area-wise">
                                    <span>Total Area (sq ft)</span>
                                    <input type="number" [(ngModel)]="areaSqft" (keyup)="areaWiseCalculat()">
                                </div>
                                <div class="tsap">
                                    <p class="qftp"><span>Total Price</span></p>
                                    <p class="total-sqft-area-price-p"> &#8377;{{total_Sqft_amount | number:'1.0-1'}}
                                    </p>
                                    <p class="taxes">{{_as.price_help_text_one}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="price-offer" *ngIf="productDetail?.calculation_type ==='sheet_wise'">
                            <ul class="pbul">
                                <li>
                                    <div class="perb">
                                        <p>Coverage Area </p>
                                        <p>{{productDetail?.covered_area_par_sheet | number:'1.2-2'}} sqft / Board</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="perb">
                                        <p>Price </p>
                                        <p>&#8377; {{productDetail?.par_box_amount | number:'1.0-1'}} / Board</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="tsap">
                                <div class="total-sqft-area-price">
                                    <p><span>Total Price</span></p>
                                    <p class="total-sqft-area-price-p">&#8377;{{total_Sqft_amount | number:'1.0-1'}}</p>
                                    <p class="taxes">{{_as.price_help_text_one}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hr-1" *ngIf="productDetail?.price"></div>
                    <div class="w-100 d-block" *ngIf="!is_addToCart ">
                        <div class="qtbx">
                            <span class="sbws" *ngIf="productDetail?.calculation_type ==='sqft_wise'">Box
                                Quantity</span>
                            <span class="sbws" *ngIf="productDetail?.calculation_type ==='sheet_wise'">Board
                                Quantity</span>
                            <span
                                *ngIf="productDetail?.calculation_type !=='sqft_wise' && productDetail?.calculation_type !=='sheet_wise' "></span>
                            <div class="product-quantity" *ngIf="_cart.is_my_list">
                                <div class="product-btns sbwspqpb">
                                    <button [ngClass]="{'product-btns-disabled':quantity === 1 }"
                                        (click)="decreaseQty()">-</button>
                                    <input type="text" [(ngModel)]="quantity" min="1" [max]="max_value_qty"
                                        (keyup)="addQty()">
                                    <button (click)="increaseQty()"
                                        [ngClass]="{'product-btns-disabled':(quantity===20 && productDetail?.calculation_type !=='sqft_wise') }">+</button>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ab-modal-footer">
                        <button (click)="closeQty()">CLOSE</button>
                        <button (click)="continueToAdd(productDetail)">Add to Cart</button>
                    </div>
                </div>
            </p-sidebar>
        </div>
    </div>
</div>

<!-----------city popup--------------->
<div class="basic-info-popup" *ngIf="!_as?.isOnMobilePlatform">
    <p-dialog [(visible)]="displayCityPopup" [showHeader]="false" [modal]="true" [style]="{ width: '650px', }" [draggable]="false"
        [resizable]="false">
        <div class="close-popup" (click)="displayCityPopup=false">
            <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close"
              loading="lazy" ngOptimizedImage>
        </div>
        <div class="row">
            <div class="col-12">
                <h5 class="city-heading mb-3">Select your city</h5>
                <div class="city-carousel">
                    <ul class="retailers-city-ul">
                        <li  *ngFor="let city of _ds?.citys;let i=index">
                            <a [title]="city.label" (click)="onSelectCity(city.value)">
                                <div class="city-img" [ngClass]="{'active-city':activeCity_id===city.value}">
                                    <img [src]="city.icon" alt="city image">
                                    <p>{{city.label}}</p>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </p-dialog>

</div>
<div class="basic-info-popup" *ngIf="_as?.isOnMobilePlatform">
<p-sidebar [(visible)]="displayCityPopup" position="bottom">
    <div class="close-popup" (click)="displayCityPopup=false">
        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close"
          loading="lazy" ngOptimizedImage>
    </div>
    <div class="row">
        <div class="col-12">
            <h5 class="city-heading mb-3">Select your city</h5>
            <div class="city-carousel">
                <ul class="retailers-city-ul">
                    <li  *ngFor="let city of _ds?.citys;let i=index">
                        <a [title]="city.label" (click)="onSelectCity(city.value)">
                            <div class="city-img" [ngClass]="{'active-city':activeCity_id===city.value}">
                                <img [src]="city.icon" alt="city image">
                                <p>{{city.label}}</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</p-sidebar>
</div>